import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { isSafeMode } from '../lib/safeMode';
import { useT } from '../i18n';
import { VideoCard } from '../components/VideoCard';
import { Seo } from '../components/Seo';

export default function SearchPage() {
    const [params] = useSearchParams();
    const q = params.get('q') || '';
    const t = useT();
    const [items, setItems] = useState([]);
    useEffect(() => {
        (async () => {
            const r = await api.get('/videos', { params: { search: q, limit: 60 } });
            let found = r.data.items || [];
            if (isSafeMode()) found = found.filter((v) => !v.is_adult);
            setItems(found);
        })();
    }, [q]);
    return (
        <main className="mx-auto max-w-[1400px] px-3 sm:px-5 lg:px-8 py-6 md:py-10 pb-24 md:pb-12" data-testid="search-page">
            <Seo path={`/cerca?q=${encodeURIComponent(q)}`} title={q ? `Cerca: ${q}` : 'Cerca vídeos'} description={q ? `Resultats de cerca per ${q} a Albambam, la plataforma de vídeo en català.` : 'Cerca vídeos, shorts i creadors a Albambam.'} />
            <h1 className="font-display text-2xl mb-1" dangerouslySetInnerHTML={{ __html: t('search.title', { q: `<span class="alb-text-gradient">${q.replace(/[<>&]/g, '')}</span>` }) }} />
            <div className="text-sm text-[color:var(--alb-text-muted)] mb-5">{t('search.count', { n: items.length })}</div>
            {items.length === 0 ? (
                <div className="text-[color:var(--alb-text-muted)] text-sm">{t('search.empty')}</div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {items.map((v) => <VideoCard key={v.video_id} video={v} />)}
                </div>
            )}
        </main>
    );
}
